import React, { useState, useEffect } from "react";
import {
  // Alert,
  Button,
  ButtonGroup,
  Container,
  // Card,
  Col,
  Form,
  Row,
  // Modal,
  Spinner,
  // Dropdown,
  // Tooltip,
  // OverlayTrigger,
  Table,
} from "react-bootstrap";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import { Radar } from "react-chartjs-2";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import config from "../../config";
// import { Formik } from "formik";

import CustomNavbar from "../../components/CustomNavbar";
// import CustomTable from "../../components/CustomTable";
// import CustomPagint from "../../components/CustomPagint";

// import messages from "../../redux/messages";
import SidebarDashboard from "../../components/SidebarDashboard";
import {
  deleteOverview,
  editOverview,
  getOverview,
  saveOverview,
} from "../../redux/evaluacion_desempenio/Overview/actions";
import CheckRequired from "../../components/evaluacion_desempenio/CheckRequired";
import { useHistory } from "react-router-dom";
import LinkDescargaGD from "../../components/gestorDocumental/LinkDescargaGD";

// import cssBoostrap from "bootstrap/dist/css/bootstrap.min.css";
// import cssMain from "../../css/main.css";
// import cssKis from "../../css/kislev.css";

// ChartJS.register(
//   RadialLinearScale,
//   // PointElement,
//   LineElement,
//   Filler,
//   Tooltip,
//   Legend
// );

const Overview = (props) => {
  const { carpeta, tipoDocumentoGD, tipoDocumento, descripcion } =
    config.gestorDocumental.evaluacion;
  const { area, email } = config.gestorDocumental;

  const filters = [
    { id: "competencia", desc: "Competencia" },
    { id: "factores", desc: "Factores" },
  ];
  // const fecha = new Date();
  // const [_fecha, setFecha] = useState(fecha.getFullYear());
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const [showWrapper, setShowWrapper] = useState(true);
  const [loadingPrint, setLoadingPrint] = useState(false);
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "competencia",
    desc: "Competencia",
  });
  const [Resultado] = useState({
    labels: [
      "Compromiso",
      "Orientación al cliente",
      "Habilidades de comunicación",
      "Adaptación al cambio",
      "Innovación",
      "Rigor profesional",
      "Liderazgo",
      "Innovación",
    ],
    datasets: [
      {
        label: "Puntaje",
        backgroundColor: "rgba(4, 127, 243)",
        borderColor: "rgb(14, 127, 243)",
        data: [65, 59, 90, 81, 56, 55, 40, 40],
      },
      {
        label: "Esperado",
        backgroundColor: "rgba(243, 87, 4)",
        borderColor: "rgb(243, 87, 4)",
        data: [28, 48, 40, 19, 96, 27, 100, 40],
      },
    ],
  });

  const dispatch = useDispatch();
  const history = useHistory();

  const { loading, overviewsLength, overviews, overviewError } = useSelector(
    (store) => store.overview
  );

  // Métodos
  const _getOverview = () =>
    // _anio = fecha.getFullYear()
    {
      dispatch(
        getOverview({
          id: parseInt(props.match.params.idEvaluation),
          // anio: _anio,
        })
      );
    };
  useEffect(() => {
    _getOverview();
  }, []);

  const htmlToImg = () => {
    setLoadingPrint(true);
    document.getElementById("printId2").style.display = "none";
    document.getElementById("printId3").style.display = "none";
    document.getElementById("codigoId1").style.display = "block";
    const input = document.getElementById("captureAll");
    html2canvas(input).then((canvas0) => {
      var imgWidth = 200;
      var pageHeight = 344;
      var imgHeight = (canvas0.height * imgWidth) / canvas0.width;
      var heightLeft0 = imgHeight;
      var position = 6;
      const pdf = new jsPDF("p", "mm", [215, 354]);
      // var pageHeight1 = pdf.internal.pageSize.height;
      // if (pageHeight1 - pageHeight <= 0) {
      heightLeft0 -= pageHeight;
      if (heightLeft0 >= 0) {
        document.getElementById("codigoId2").style.display = "block";
        const data = document.getElementById("capture");
        html2canvas(data).then((canvas) => {
          var imgWidth = 200;
          var pageHeight = 344;
          var imgHeight = (canvas.height * imgWidth) / canvas.width;
          var heightLeft = imgHeight;
          var position = 6;
          // var pageHeight1 = doc.internal.pageSize.height;
          // var pageHeightLeft = pageHeight;
          heightLeft -= pageHeight;
          // if (pageHeight1 - pageHeight <= 0) {
          if (heightLeft >= 0) {
            document.getElementById("comentEval1").style.display = "none";
            document.getElementById("comentEval2").style.display = "block";
            const dataC = document.getElementById("capture");
            html2canvas(dataC).then((canvasC) => {
              var imgWidthC = 200;
              var imgHeightC = (canvasC.height * imgWidth) / canvasC.width;
              var positionC = 6;
              pdf.addImage(
                canvasC,
                "PNG",
                8,
                positionC,
                imgWidthC,
                imgHeightC,
                "",
                "FAST"
              );
            });
            // document.getElementById("codigoId1").style.display = "none";
            // const data1 = document.getElementById("capture1");
            // const data2 = document.getElementById("capture2");
            // document.getElementById("codigoId3").style.display = "block";
            // document.getElementById("codigoId4").style.display = "block";
            // html2canvas(data1).then((_canvas1) => {
            //   var imgWidth3 = 200;
            //   var imgHeight3 = (_canvas1.height * imgWidth) / _canvas1.width;
            //   doc.addImage(
            //     _canvas1,
            //     "PNG",
            //     8,
            //     position,
            //     imgWidth3,
            //     imgHeight3,
            //     "",
            //     "FAST"
            //   );
            // });
            // html2canvas(data2).then((_canvas2) => {
            //   var imgWidth4 = 200;
            //   var imgHeight4 = (_canvas2.height * imgWidth) / _canvas2.width;
            //   doc.addPage();
            //   doc.addImage(
            //     _canvas2,
            //     "PNG",
            //     8,
            //     position,
            //     imgWidth4,
            //     imgHeight4,
            //     "",
            //     "FAST"
            //   );
            // });
          } else {
            document.getElementById("comentEval1").style.display = "block";
            document.getElementById("comentEval2").style.display = "none";
            const dataD = document.getElementById("capture");
            html2canvas(dataD).then((canvasD) => {
              var imgWidthD = 200;
              var imgHeightD = (canvasD.height * imgWidth) / canvasD.width;
              var positionD = 6;
              pdf.addImage(
                canvasD,
                "PNG",
                8,
                positionD,
                imgWidthD,
                imgHeightD,
                "",
                "FAST"
              );
            });
            // doc.addImage(
            //   canvas,
            //   "PNG",
            //   8,
            //   position,
            //   imgWidth,
            //   imgHeight,
            //   "",
            //   "FAST"
            // );
          }
          heightLeft -= pageHeight;

          const data3 = document.getElementById("comentarioId");
          html2canvas(data3).then((_canvas) => {
            var imgWidth2 = 200;
            var imgHeight2 = (_canvas.height * imgWidth) / _canvas.width;
            pdf.addPage();
            pdf.addImage(
              _canvas,
              "PNG",
              8,
              position,
              imgWidth2,
              imgHeight2,
              "",
              "FAST"
            );
            pdf.save("resumen general.pdf");
            setLoadingPrint(false);
            document.getElementById("printId2").style.display = "block";
            document.getElementById("printId3").style.display = "block";
            document.getElementById("codigoId1").style.display = "none";
            document.getElementById("codigoId2").style.display = "none";
            document.getElementById("codigoId3").style.display = "none";
            document.getElementById("codigoId4").style.display = "none";
          });
          // while (heightLeft >= 0) {
          //   position = heightLeft - imgHeight;
          //   doc.addPage();
          //   doc.addImage(
          //     canvas,
          //     "PNG",
          //     0,
          //     position,
          //     imgWidth,
          //     imgHeight,
          //     "",
          //     "FAST"
          //   );
          //   heightLeft -= pageHeight;
          // }
          // doc.save("resumen general.pdf");
          // setLoadingPrint(false);
          // document.getElementById(
          //   "printId2"
          // ).style.display = "block";
          // document.getElementById(
          //   "printId3"
          // ).style.display = "block";
        });
      } else {
        pdf.addImage(
          canvas0,
          "PNG",
          8,
          position,
          imgWidth,
          imgHeight,
          "",
          "FAST"
        );
        pdf.save("resumen general.pdf");
        document.getElementById("codigoId1").style.display = "none";
        document.getElementById("codigoId2").style.display = "none";
        document.getElementById("printId2").style.display = "block";
        document.getElementById("printId3").style.display = "block";
        heightLeft0 -= pageHeight;
        setLoadingPrint(false);
      }
    });
    // setShowWrapper(false);
    // setLoadingPrint(true);
    // const input = document.getElementById("capture");
    // html2canvas(input).then((canvas) => {
    //   let imgWidth = 208;
    //   let imgHeight =
    //     (canvas.height * imgWidth) / canvas.width;
    //   const imgData = canvas.toDataURL("img/png");
    //   const pdf = new jsPDF("p", "mm", "a4");
    //   pdf.addImage(
    //     imgData,
    //     "PNG",
    //     0,
    //     5,
    //     imgWidth,
    //     imgHeight
    //   );
    //   // pdf.output("dataurlnewwindow");
    //   pdf.save("resumen general.pdf");
    //   setLoadingPrint(false);
    // });

    // const input = document.getElementById("captureAll");
    // html2canvas(input).then((canvas) => {
    //   const pdf = new jsPDF("p", "mm", [215, 354]);
    //   // const imgData = canvas.toDataURL("img/png");
    //   var imgWidth = 200;
    //   var imgHeight = (canvas.height * imgWidth) / canvas.width;
    //   // var heightLeft = imgHeight;
    //   var position = 6;
    //   // const doc = new jsPDF("p", "mm", [215, 354]);
    //   pdf.addImage(canvas, "PNG", 8, position, imgWidth, imgHeight, "", "FAST");
    //   // pdf.output("dataurlnewwindow");
    //   pdf.save("resumen general.pdf");
    //   setLoadingPrint(false);
    // });
  };

  const renderSwitch = (param) => {
    switch (param) {
      case 1:
        return "Primer";
      case 2:
        return "Segundo";
      case 3:
        return "Tercero";
      case 4:
        return "Cuarto";
      case 5:
        return "Quinto";
      case 6:
        return "Sexto";
      default:
        return "Septimo";
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <div id="printId">
        <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
        <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      </div>
      <div className={showWrapper ? "custom-wrapper" : ""}>
        <Container fluid>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            <>
              <div id="captureAll">
                <div id="capture">
                  <div id="capture1">
                    <div id="codigoId1">
                      <Row className="mb-3 d-flex flex-wrap justify-content-end align-items-center">
                        <Col xs="auto">
                          <p className="text-black-50 mx-3">
                            <b>F-896</b>
                          </p>
                        </Col>
                      </Row>
                    </div>
                    <div id="codigoId3">
                      <Row className="mb-3 d-flex flex-wrap justify-content-end align-items-center">
                        <Col xs="auto">
                          <p className="text-black-50 mx-3">
                            <b>F-896</b>
                          </p>
                        </Col>
                      </Row>
                    </div>
                    <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 py-2 rounded card-crear text-muted d-flex flex-wrap justify-content-between align-items-center">
                      <Col md="12">
                        <Row className="justify-content-sm-end align-items-center flex-nowrap">
                          <Col xs="auto" className="px-0 mr-2">
                            <Button
                              variant="link"
                              size="sm"
                              id="printId2"
                              className="text-light rounded px-0"
                              onClick={
                                () => history.goBack()
                                // history.push(
                                //   `/evaluacion-desempenio/monitor-de-evaluación/${props.match.params.idColab}/${props.match.params.nombreColab}/${props.match.params.idFuncion}/${props.match.params.nombreFuncion}/${props.match.params.idDep}/${props.match.params.nombreDep}/${props.match.params.idEmpresa}`
                                // )
                              }
                            >
                              <i className="material-icons">arrow_back</i>
                            </Button>
                          </Col>
                          <Col className="px-0 py-1">
                            <h6 className="font-weight-bold text-uppercase">
                              Evaluación por COMPETENCIA y por FACTOR
                            </h6>
                          </Col>
                          {/* <Col xs="auto">
                      <Form.Control
                        id="date"
                        name="date"
                        placeholder="Fecha"
                        defaultValue={_fecha}
                        onKeyDown={onSearch}
                        className="rounded-pill form-control-sm"
                        type="number"
                      ></Form.Control>
                    </Col> */}
                          <Col xs="auto">
                            <ButtonGroup>
                              <Button
                                id="printId3"
                                variant="link"
                                size="sm"
                                className="text-light rounded-circle"
                                disabled={loadingPrint}
                                onClick={() => {
                                  htmlToImg();
                                }}
                              >
                                {loadingPrint ? (
                                  <div className="d-flex justify-content-center">
                                    <Spinner
                                      animation="border"
                                      role="status"
                                      className="d-flex justify-content-center"
                                      size="sm"
                                    />
                                  </div>
                                ) : (
                                  <i className="material-icons">print</i>
                                )}
                              </Button>
                            </ButtonGroup>
                          </Col>
                        </Row>
                      </Col>
                    </div>
                    <Col md="12" className="mt-3">
                      <Row className="d-flex flex-wrap justify-content-sm-end align-items-center">
                        <Col md="4" xs="auto">
                          <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                            <Form.Label column md="3" xs="auto">
                              <b>Empresa:</b>
                            </Form.Label>
                            <Col md="8" xs="auto">
                              <Form.Control
                                className="rounded-pill form-control-sm"
                                type="text"
                                disabled
                                value={
                                  overviews && overviews.informacion
                                    ? overviews.informacion.data[0].empresa
                                    : ""
                                }
                              ></Form.Control>
                            </Col>
                          </Row>
                        </Col>
                        <Col md="4" xs="auto">
                          <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                            <Form.Label column md="3" xs="auto">
                              <b>Fecha actual:</b>
                            </Form.Label>
                            <Col md="8" xs="auto">
                              <Form.Control
                                className="rounded-pill form-control-sm"
                                type="text"
                                disabled
                                value={moment().format("DD/MM/YYYY")}
                              ></Form.Control>
                            </Col>
                          </Row>
                        </Col>
                        <Col md="4" xs="auto">
                          <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                            <Form.Label column md="3" xs="auto">
                              <b>Tipo de evaluación:</b>
                            </Form.Label>
                            <Col md="8" xs="auto">
                              <Form.Control
                                className="rounded-pill form-control-sm"
                                type="text"
                                disabled
                                value={
                                  overviews && overviews.informacion
                                    ? overviews.informacion.data[0]
                                        .tipo_evaluacion
                                    : ""
                                }
                              ></Form.Control>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <Col md="12" className="mt-2">
                      <Row className="d-flex flex-wrap justify-content-sm-end align-items-center">
                        <Col md="4" xs="auto">
                          <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                            <Form.Label column md="3" xs="auto">
                              <b>Fecha de evaluación:</b>
                            </Form.Label>
                            <Col md="8" xs="auto">
                              <Form.Control
                                className="rounded-pill form-control-sm"
                                type="text"
                                disabled
                                value={
                                  overviews &&
                                  overviews.informacion &&
                                  overviews.informacion.data[0].fecha_evaluacion
                                    ? moment(
                                        overviews.informacion.data[0]
                                          .fecha_evaluacion
                                      ).format("DD/MM/YYYY")
                                    : "No realizada"
                                }
                              ></Form.Control>
                            </Col>
                          </Row>
                        </Col>
                        <Col md="4" xs="auto">
                          <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                            <Form.Label column md="3" xs="auto">
                              <b>Periodo:</b>
                            </Form.Label>
                            <Col md="8" xs="auto">
                              <Form.Control
                                className="rounded-pill form-control-sm"
                                type="text"
                                disabled
                                value={
                                  overviews && overviews.informacion
                                    ? `${renderSwitch(
                                        overviews.informacion.data[0].periodo
                                      )} Periodo`
                                    : ""
                                }
                              ></Form.Control>
                            </Col>
                          </Row>
                        </Col>
                        <Col md="4" xs="auto">
                          <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                            <Form.Label column md="3" xs="auto">
                              <b>Frequencia:</b>
                            </Form.Label>
                            <Col md="8" xs="auto">
                              <Form.Control
                                className="rounded-pill form-control-sm"
                                type="text"
                                disabled
                                value={
                                  overviews && overviews.informacion
                                    ? overviews.informacion.data[0].frecuencia
                                    : ""
                                }
                              ></Form.Control>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 pt-3 pb-2 rounded card-crear text-muted d-flex flex-wrap justify-content-between align-items-center">
                      <Row className="justify-content-sm-end align-items-center flex-nowrap">
                        <Col>
                          <h6 className="font-weight-bold text-uppercase">
                            Datos del evaluado
                          </h6>
                        </Col>
                      </Row>
                    </div>
                    <Col md="12" className="mt-3">
                      <Row className="mb-2 d-flex flex-wrap justify-content-sm-between align-items-center">
                        <Col md="6" xs="auto">
                          <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                            <Form.Label column md="3" xs="auto">
                              <b>Nombre:</b>
                            </Form.Label>
                            <Col md="9" xs="auto">
                              <Form.Control
                                className="rounded-pill form-control-sm"
                                type="text"
                                disabled
                                value={
                                  overviews && overviews.informacion
                                    ? overviews.informacion.data[0].nombre
                                    : ""
                                }
                              ></Form.Control>
                            </Col>
                          </Row>
                        </Col>
                        <Col md="6" xs="auto">
                          <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                            <Form.Label column md="3" xs="auto">
                              <b>Función:</b>
                            </Form.Label>
                            <Col md="9" xs="auto">
                              <Form.Control
                                className="rounded-pill form-control-sm"
                                type="text"
                                disabled
                                value={
                                  overviews && overviews.informacion
                                    ? overviews.informacion.data[0].funcion
                                    : ""
                                }
                              ></Form.Control>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row className="mt-3 d-flex flex-wrap justify-content-sm-between align-items-center">
                        <Col md="6" xs="auto">
                          <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                            <Form.Label column md="3" xs="auto">
                              <b>Departamento:</b>
                            </Form.Label>
                            <Col md="9" xs="auto">
                              <Form.Control
                                className="rounded-pill form-control-sm"
                                type="text"
                                disabled
                                value={
                                  overviews && overviews.informacion
                                    ? overviews.informacion.data[0].departamento
                                    : ""
                                }
                              ></Form.Control>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <div className="mt-3 mb-1 pl-md-4 pr-md-3 pl-2 pr-1 pt-3 pb-2 rounded card-crear text-muted d-flex flex-wrap justify-content-between align-items-center">
                      <Row className="justify-content-sm-end align-items-center flex-nowrap">
                        <Col>
                          <h6 className="font-weight-bold text-uppercase">
                            Datos del evaluador
                          </h6>
                        </Col>
                      </Row>
                    </div>
                    {overviews &&
                      overviews.informacion &&
                      overviews.informacion.data[0].evaluadores.map((item) => (
                        <>
                          <Col md="12" className="mt-3">
                            <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                              <Col md="6" xs="auto">
                                <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                                  <Form.Label column md="3" xs="auto">
                                    <b>Nombre:</b>
                                  </Form.Label>
                                  <Col md="9" xs="auto">
                                    <Form.Control
                                      className="rounded-pill form-control-sm"
                                      type="text"
                                      disabled
                                      value={item.Evaluador}
                                    ></Form.Control>
                                  </Col>
                                </Row>
                              </Col>
                              <Col md="6" xs="auto">
                                <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                                  <Form.Label column md="3" xs="auto">
                                    <b>Función:</b>
                                  </Form.Label>
                                  <Col md="9" xs="auto">
                                    <Form.Control
                                      className="rounded-pill form-control-sm"
                                      type="text"
                                      disabled
                                      value={item.Función}
                                    ></Form.Control>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row className="mt-3 d-flex flex-wrap justify-content-sm-between align-items-center">
                              <Col md="6" xs="auto">
                                <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                                  <Form.Label column md="3" xs="auto">
                                    <b>Relación:</b>
                                  </Form.Label>
                                  <Col md="9" xs="auto">
                                    <Form.Control
                                      className="rounded-pill form-control-sm"
                                      type="text"
                                      disabled
                                      value={item.Relación}
                                    ></Form.Control>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                        </>
                      ))}
                    <Table responsive size="sm" className="mt-3">
                      <thead className="bg-dark text-light">
                        <tr className="bdrLeft bdrRight">
                          <th className="bdrLeft text-uppercase text-center">
                            Puntuación total
                          </th>
                          <th className="text-uppercase text-center">
                            Desempeño
                          </th>
                          <th className="text-uppercase text-center">
                            Puntuación total por factor
                          </th>
                          <th className="text-uppercase text-center">
                            Desempeño por factor
                          </th>
                          <th className="text-uppercase text-center">
                            Puntuación total por competencia
                          </th>
                          <th className="bdrRight text-uppercase text-center">
                            Desempeño por competencia
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              color:
                                overviews.informacion &&
                                overviews.informacion.data &&
                                overviews.informacion.data[0]
                                  .total_desempenio &&
                                parseInt(
                                  overviews.informacion.data[0].total_desempenio
                                ) &&
                                parseInt(
                                  overviews.informacion.data[0].total_desempenio
                                ) > 60 &&
                                parseInt(
                                  overviews.informacion.data[0].total_desempenio
                                ) < 75
                                  ? "orange"
                                  : "unset",
                            }}
                            className={
                              overviews.informacion &&
                              overviews.informacion.data &&
                              overviews.informacion.data[0].total_desempenio &&
                              parseInt(
                                overviews.informacion.data[0].total_desempenio
                              ) &&
                              parseInt(
                                overviews.informacion.data[0].total_desempenio
                              ) < 61
                                ? "text-danger text-center text-uppercase"
                                : overviews.informacion &&
                                  overviews.informacion.data &&
                                  overviews.informacion.data[0]
                                    .total_desempenio &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) > 74 &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) < 90
                                ? "text-warning text-center text-uppercase"
                                : overviews.informacion &&
                                  overviews.informacion.data &&
                                  overviews.informacion.data[0]
                                    .total_desempenio &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) > 89 &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) < 101
                                ? "text-success text-center text-uppercase"
                                : "text-center text-uppercase"
                            }
                          >
                            <b>
                              {overviews && overviews.informacion
                                ? `${
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  } ${
                                    parseInt(
                                      overviews.informacion.data[0]
                                        .total_desempenio
                                    )
                                      ? "%"
                                      : ""
                                  }`
                                : ""}
                            </b>
                          </td>
                          <td
                            style={{
                              color:
                                overviews.informacion &&
                                overviews.informacion.data &&
                                overviews.informacion.data[0]
                                  .total_desempenio &&
                                parseInt(
                                  overviews.informacion.data[0].total_desempenio
                                ) &&
                                parseInt(
                                  overviews.informacion.data[0].total_desempenio
                                ) > 60 &&
                                parseInt(
                                  overviews.informacion.data[0].total_desempenio
                                ) < 75
                                  ? "orange"
                                  : "unset",
                            }}
                            className={
                              overviews.informacion &&
                              overviews.informacion.data &&
                              overviews.informacion.data[0].total_desempenio &&
                              parseInt(
                                overviews.informacion.data[0].total_desempenio
                              ) &&
                              parseInt(
                                overviews.informacion.data[0].total_desempenio
                              ) < 61
                                ? "text-danger text-center text-uppercase"
                                : overviews.informacion &&
                                  overviews.informacion.data &&
                                  overviews.informacion.data[0]
                                    .total_desempenio &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) > 74 &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) < 90
                                ? "text-warning text-center text-uppercase"
                                : overviews.informacion &&
                                  overviews.informacion.data &&
                                  overviews.informacion.data[0]
                                    .total_desempenio &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) > 89 &&
                                  parseInt(
                                    overviews.informacion.data[0]
                                      .total_desempenio
                                  ) < 101
                                ? "text-success text-center text-uppercase"
                                : "text-center text-uppercase"
                            }
                          >
                            <b>
                              {overviews && overviews.informacion
                                ? overviews.informacion.data[0].desempenio
                                : ""}
                            </b>
                          </td>
                          <td className="text-uppercase text-center">
                            <b>
                              {overviews && overviews.informacion
                                ? `${
                                    overviews.informacion.data[0]
                                      .nota_total_factor
                                  }
                            ${
                              parseInt(
                                overviews.informacion.data[0].nota_total_factor
                              )
                                ? "%"
                                : ""
                            }`
                                : ""}
                            </b>
                          </td>
                          <td className="text-uppercase text-center">
                            <b>
                              {overviews && overviews.informacion
                                ? overviews.informacion.data[0]
                                    .nota_total_factor_desempenio
                                : ""}
                            </b>
                          </td>
                          <td className="text-uppercase text-center">
                            <b>
                              {overviews && overviews.informacion
                                ? `${
                                    overviews.informacion.data[0]
                                      .nota_total_competencia
                                  }
                            ${
                              parseInt(
                                overviews.informacion.data[0]
                                  .nota_total_competencia
                              )
                                ? "%"
                                : ""
                            }`
                                : ""}
                            </b>
                          </td>
                          <td className="text-uppercase text-center">
                            <b>
                              {overviews && overviews.informacion
                                ? overviews.informacion.data[0]
                                    .nota_total_competencia_desempeno
                                : ""}
                            </b>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                    <Table responsive size="sm" className="mt-3">
                      <thead className="bg-dark text-light">
                        <tr className="bdrLeft bdrRight">
                          <th className="bdrLeft text-uppercase text-center">
                            Factor
                          </th>
                          {overviews &&
                            overviews.metricas_factor &&
                            overviews.metricas_factor.map((item, index) => (
                              <>
                                <th
                                  className={`${
                                    overviews.metricas_factor.length - 1 ===
                                    index
                                      ? "bdrRight"
                                      : ""
                                  } text-uppercase text-center`}
                                >
                                  {item}
                                </th>
                              </>
                            ))}
                        </tr>
                      </thead>
                      <tbody>
                        {overviews &&
                          overviews.matriz_marcas_factor &&
                          overviews.matriz_marcas_factor.map((item) => (
                            <>
                              <tr>
                                <td
                                  style={{
                                    minWidth: "90px",
                                  }}
                                  className="text-uppercase"
                                >
                                  <b>{item.factor}</b>
                                </td>
                                <td className="text-center">
                                  {item.MDE ?? 0}
                                </td>
                                <td className="text-center">
                                  {item.DDE ?? 0}
                                </td>
                                <td className="text-center">
                                  {item.AE ?? 0}
                                </td>
                                <td className="text-center">
                                  {item.ME ?? 0}
                                </td>
                                <td className="text-center">
                                  {item.SB ?? 0}
                                </td>
                                {/* {item.puntuaciones &&
                                  item.puntuaciones.map((_item) => (
                                    <>
                                      <td className="text-center">{_item}</td>
                                    </>
                                  ))} */}
                              </tr>
                            </>
                          ))}
                      </tbody>
                    </Table>
                  </div>
                  <div id="capture2">
                    <div id="codigoId4">
                      <Row className="mb-3 d-flex flex-wrap justify-content-end align-items-center">
                        <Col xs="auto">
                          <p className="text-black-50 mx-3">
                            <b>F-896</b>
                          </p>
                        </Col>
                      </Row>
                    </div>
                    <Row className="mt-3 mb-1">
                      <Col md="6">
                        <Table responsive size="sm">
                          <thead className="bg-dark text-light">
                            <tr className="bdrLeft bdrRight">
                              <th className="bdrLeft text-uppercase text-center">
                                Competencia
                              </th>
                              <th className="text-uppercase text-center">
                                Puntaje
                              </th>
                              <th className="text-uppercase text-center">
                                Esperado
                              </th>
                              <th className="bdrRight text-uppercase text-center">
                                Semaforo
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {overviews &&
                              overviews.matriz_competencia &&
                              overviews.matriz_competencia.map((item) => (
                                <>
                                  <tr>
                                    <td className="text-uppercase">
                                      <b>{item.nombre_competencia}</b>
                                    </td>
                                    <td className="text-center">
                                      {item.puntaje_obtenido}%
                                    </td>
                                    <td className="text-center">
                                      {item.puntaje_esperado}%
                                    </td>
                                    <td>
                                      <Col
                                        className={
                                          item.semaforo === 0
                                            ? "circle-green d-flex flex-wrap justify-content-center align-items-center"
                                            : "circle-red d-flex flex-wrap justify-content-center align-items-center"
                                        }
                                        // className="d-flex flex-wrap justify-content-center align-items-center"
                                      >
                                        {/* <div
                                        className={
                                          item.semaforo === 0
                                            ? "circle-green p-1"
                                            : "circle-red p-1"
                                        }
                                      > */}
                                        {item.puntaje_obtenido -
                                          item.puntaje_esperado}
                                        %{/* </div> */}
                                      </Col>
                                    </td>
                                  </tr>
                                </>
                              ))}
                            {/* <tr>
                        <td>Competencia 1</td>
                        <td>25%</td>
                        <td>95%</td>
                        <td>
                          <div className="circle-red"></div>
                        </td>
                      </tr>
                      <tr>
                        <td>Competencia 2</td>
                        <td>25%</td>
                        <td>95%</td>
                        <td>
                          <div className="circle-green"></div>
                        </td>
                      </tr> */}
                          </tbody>
                        </Table>
                      </Col>
                      <Col md="4" className="mx-auto">
                        {overviews && overviews.dashboard && (
                          <>
                            <Row>
                              {overviews.dashboard.datasets[0] && (
                                <Col xs="auto" className="mx-auto mb-1">
                                  <Row>
                                    <div
                                      style={{
                                        width: "100px",
                                        color:
                                          overviews.dashboard.datasets[0]
                                            .backgroundColor,
                                        backgroundColor:
                                          overviews.dashboard.datasets[0]
                                            .backgroundColor,
                                      }}
                                      className="rounded mr-1"
                                    >
                                      {" "}
                                    </div>
                                    <div className="text-muted mr-2">
                                      <b>
                                        {overviews.dashboard.datasets[0].label}
                                      </b>
                                    </div>
                                  </Row>
                                </Col>
                              )}
                              {overviews.dashboard.datasets[1] && (
                                <Col xs="auto" className="mx-auto mb-1">
                                  <Row>
                                    <div
                                      style={{
                                        width: "100px",
                                        color:
                                          overviews.dashboard.datasets[1]
                                            .backgroundColor,
                                        backgroundColor:
                                          overviews.dashboard.datasets[1]
                                            .backgroundColor,
                                      }}
                                      className="rounded mr-1"
                                    >
                                      {" "}
                                    </div>
                                    <div className="text-muted">
                                      <b>
                                        {overviews.dashboard.datasets[1].label}
                                      </b>
                                    </div>
                                  </Row>
                                </Col>
                              )}
                            </Row>
                            <Radar
                              // height={155}
                              data={overviews.dashboard}
                              options={{
                                fill: false,
                                interaction: {
                                  intersect: false,
                                },
                                responsive: true,
                                plugins: {
                                  legend: {
                                    display: false,
                                  },
                                },
                                //scales: {
                                //  x: { stacked: true },
                                //  y: { stacked: true }
                                // },
                                // radius: 60,
                              }}
                            />
                          </>
                        )}
                      </Col>
                    </Row>
                    <Row className="px-3 mt-3 mb-5 d-flex flex-wrap justify-content-start align-items-center">
                      <Col md="6" xs="auto">
                        <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                          <Form.Label
                            column
                            md="5"
                            xs="auto"
                            className="text-uppercase"
                          >
                            <b>Tipo de plan de acción:</b>
                          </Form.Label>
                          <Col md="7" xs="auto">
                            <Form.Control
                              className="rounded-pill form-control-sm"
                              type="text"
                              disabled
                              value={
                                overviews.informacion &&
                                overviews.informacion.data[0] &&
                                overviews.informacion.data[0]
                                  .tipo_plan_accion_obj &&
                                overviews.informacion.data[0]
                                  .tipo_plan_accion_obj[0] &&
                                overviews.informacion.data[0]
                                  .tipo_plan_accion_obj[0].descripcion
                                  ? overviews.informacion.data[0]
                                      .tipo_plan_accion_obj[0].descripcion
                                  : "No ingresado"
                              }
                            ></Form.Control>
                          </Col>
                        </Row>
                      </Col>
                      <Col md="6" xs="auto">
                        <Row className="d-flex flex-wrap justify-content-start align-items-center">
                          <Col xs="auto">
                            <label className="mx-3 text-uppercase">
                              <b>Plan de acción:</b>
                            </label>
                          </Col>
                          <Col md="6">
                            {overviews.informacion &&
                            overviews.informacion.data &&
                            overviews.informacion.data[0]
                              .archivo_id_documento &&
                            overviews.informacion.data[0].archivo_llave ? (
                              <>
                                <ul className="list-unstyled">
                                  <LinkDescargaGD
                                    id={parseInt(
                                      props.match.params.idEvaluation
                                    )}
                                    filters={{
                                      email: email,
                                      id: overviews.informacion.data[0]
                                        .archivo_id_documento,
                                      llave:
                                        overviews.informacion.data[0]
                                          .archivo_llave,
                                    }}
                                    origen={
                                      overviews.informacion.data[0]
                                        .archivo_origen
                                    }
                                    cType={
                                      overviews.informacion.data[0]
                                        .archivo_contentTypeGD
                                    }
                                  />
                                </ul>
                              </>
                            ) : (
                              <label>No ingresado.</label>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <div id="comentEval1">
                      <Col md="12">
                        <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                          <Form.Label className="text-uppercase" column md="12">
                            <b>Comentario evaluador:</b>
                          </Form.Label>
                          <Col md="12">
                            {/* <Form.Control
                              className="rounded form-control-sm"
                              as="textarea"
                              disabled
                              value={
                                overviews.informacion &&
                                overviews.informacion.data &&
                                overviews.informacion.data[0]
                                  .comentario_evaluador
                                  ? overviews.informacion.data[0]
                                      .comentario_evaluador
                                  : ""
                              }
                            ></Form.Control> */}
                            <div
                              className="px-2 py-1 rounded border border-muted"
                              style={{
                                backgroundColor: "#F4F4F4",
                                minHeight: "100px",
                              }}
                            >
                              {overviews.informacion &&
                              overviews.informacion.data &&
                              overviews.informacion.data[0].comentario_evaluador
                                ? overviews.informacion.data[0]
                                    .comentario_evaluador
                                : ""}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </div>
                  </div>
                </div>
                <div id="comentarioId">
                  <div id="codigoId2">
                    <Row className="mb-5 d-flex flex-wrap justify-content-end align-items-center">
                      <Col xs="auto">
                        <p className="text-black-50 mx-3">
                          <b>F-896</b>
                        </p>
                      </Col>
                    </Row>
                  </div>
                  <div id="comentEval2">
                    <Col md="12">
                      <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                        <Form.Label className="text-uppercase" column md="12">
                          <b>Comentario evaluador:</b>
                        </Form.Label>
                        <Col md="12">
                          {/* <Form.Control
                            className="rounded form-control-sm"
                            as="textarea"
                            disabled
                            value={
                              overviews.informacion &&
                              overviews.informacion.data &&
                              overviews.informacion.data[0].comentario_evaluador
                                ? overviews.informacion.data[0]
                                    .comentario_evaluador
                                : ""
                            }
                          ></Form.Control> */}
                          <div
                            className="px-2 py-1 rounded border border-muted"
                            style={{
                              backgroundColor: "#F4F4F4",
                              minHeight: "100px",
                            }}
                          >
                            {overviews.informacion &&
                            overviews.informacion.data &&
                            overviews.informacion.data[0].comentario_evaluador
                              ? overviews.informacion.data[0]
                                  .comentario_evaluador
                              : ""}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </div>
                  <Col md="12" className="mt-3 mb-3">
                    <Row className="d-flex flex-wrap justify-content-sm-between align-items-center">
                      <Form.Label className="text-uppercase" column md="12">
                        <b>Comentario evaluado:</b>
                      </Form.Label>
                      <Col md="12">
                        {/* <Form.Control
                          className="rounded form-control-sm"
                          as="textarea"
                          disabled
                          value={
                            overviews.informacion &&
                            overviews.informacion.data &&
                            overviews.informacion.data[0].comentario_evaluado
                              ? overviews.informacion.data[0]
                                  .comentario_evaluado
                              : ""
                          }
                        ></Form.Control> */}
                        <div
                          className="px-2 py-1 rounded border border-muted"
                          style={{
                            backgroundColor: "#F4F4F4",
                            minHeight: "100px",
                          }}
                        >
                          {overviews.informacion &&
                          overviews.informacion.data &&
                          overviews.informacion.data[0].comentario_evaluado
                            ? overviews.informacion.data[0].comentario_evaluado
                            : ""}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col md="12">
                    <Row className="mt-5 mb-3 d-flex flex-wrap justify-content-sm-between align-items-center">
                      <Col md="4" xs="auto" className="mx-auto my-5">
                        <Row className="mt-3 d-flex flex-wrap justify-content-sm-between align-items-center">
                          <Col md="12">
                            <div className="px-2 d-flex flex-wrap justify-content-center align-items-center">
                              <p className="text-uppercase">
                                <b>
                                  {overviews &&
                                  overviews.informacion &&
                                  overviews.informacion.data &&
                                  overviews.informacion.data[0].evaluadores
                                    ? overviews.informacion.data[0]
                                        .tipo_evaluacion === "0°"
                                      ? overviews.informacion.data[0]
                                          .jefe_evaluado_nombre
                                      : overviews.informacion.data[0]
                                          .evaluadores[0].Evaluador
                                    : null}
                                </b>
                              </p>
                            </div>
                            <div className="px-2">
                              <hr
                                style={{
                                  borderColor: "black",
                                }}
                              />
                            </div>
                          </Col>
                          <Col md="12">
                            <Row className="d-flex flex-wrap justify-content-center align-items-center px-2">
                              {/* <Col
                                className="mb-1 d-flex flex-wrap justify-content-center align-items-center"
                                md="12"
                              >
                                <p className="text-uppercase">
                                  <b>
                                    {overviews &&
                                    overviews.informacion &&
                                    overviews.informacion.data &&
                                    overviews.informacion.data[0].evaluadores
                                      ? overviews.informacion.data[0]
                                          .tipo_evaluacion === "0°"
                                        ? overviews.informacion.data[0]
                                            .jefe_evaluado_nombre
                                        : overviews.informacion.data[0]
                                            .evaluadores[0].Evaluador
                                      : null}
                                  </b>
                                </p>
                              </Col> */}
                              <Col
                                className="d-flex flex-wrap justify-content-center align-items-center"
                                md="12"
                              >
                                <p className="text-uppercase">
                                  <b>
                                    {overviews && overviews.informacion
                                      ? overviews.informacion.data[0]
                                          .tipo_evaluacion === "0°"
                                        ? "Firma jefe inmediato"
                                        : "Firma evaluador"
                                      : "Firma evaluador"}
                                  </b>
                                </p>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                      <Col md="4" xs="auto" className="mx-auto my-5">
                        <Row className="mt-3 d-flex flex-wrap justify-content-sm-between align-items-center">
                          <Col md="12">
                            <div className="px-2 d-flex flex-wrap justify-content-center align-items-center">
                              <p className="text-uppercase">
                                <b>
                                  {overviews &&
                                  overviews.informacion &&
                                  overviews.informacion.data
                                    ? overviews.informacion.data[0].nombre
                                    : null}
                                </b>
                              </p>
                            </div>
                            <div className="px-2">
                              <hr
                                style={{
                                  borderColor: "black",
                                }}
                              />
                            </div>
                          </Col>
                          <Col md="12">
                            <Row className="d-flex flex-wrap justify-content-center align-items-center px-2">
                              {/* <Col
                                className="mb-1 d-flex flex-wrap justify-content-center align-items-center"
                                md="12"
                              >
                                <p className="text-uppercase">
                                  <b>
                                    {overviews &&
                                    overviews.informacion &&
                                    overviews.informacion.data
                                      ? overviews.informacion.data[0].nombre
                                      : null}
                                  </b>
                                </p>
                              </Col> */}
                              <Col
                                className="d-flex flex-wrap justify-content-center align-items-center"
                                md="12"
                              >
                                <p className="text-uppercase">
                                  <b>Firma evaluado</b>
                                </p>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </div>
              </div>
            </>
          )}
        </Container>
      </div>
    </>
  );
};

export default Overview;
